import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/tab';
import $ from 'jquery';
window.$ = window.jQuery = $;
import 'jquery.easing';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";


import { dm_reveal } from './config/scroll_reveal.js';
// import { dm_geo_locate } from './components/geo-locate.js';
import { dm_nav } from './components/nav.js';
// import { dm_search } from './components/search.js';
// import { dm_nav_vacancy } from './components/nav-vacancy.js';
import { dm_vimeo_modal } from './components/vimeo.js';
import { dm_back_to_top } from './components/back-to-top.js';

import { dm_vah_01_homepage_header } from './modules/vah-01-homepage-header.js';
// import { dm_h_01_header } from './modules/h_01_header.js';
// import { dm_h_02_header_with_media } from './modules/h_02_header_with_media.js';
// import { dm_a_02_latest_job_cards } from './modules/a_02_latest_job_cards.js';
// import { dm_a_03_more_people_stories } from './modules/a_03_more_people_stories.js';
// import { dm_c_04_feature_1 } from './modules/c_04_feature_1_drop.js';
// import { dm_c_04_feature_2 } from './modules/c_04_feature_1_rotate.js';
// import { dm_c_05_feature_2 } from './modules/c_05_feature_2.js';
// import { dm_c_06_tabbed_slider } from './modules/c_06_tabbed_slider.js';
// import { dm_c_07_history_slider } from './modules/c_07_history_slider.js';
// import { dm_c_10_featured_stories } from './modules/c_10_featured_stories.js';
import { dm_c_11_people_cards } from './modules/c-11-people-cards.js';
// import { dm_c_13_video_cards } from './modules/c_13_video_cards.js';
import { dm_c_14_perk_cards } from './modules/c_14_perk_cards.js';
// import { dm_applyCircleAnimationOnButtonHover } from "./utils/buttons.js";
// import { dm_soh_01_header } from "./modules/soh-01-header.js";
// import { dm_soc_02_stats } from "./modules/soc-02-stat.js";
import { dm_c_21_cards_scroll_horizontal } from "./modules/c-21-cards-scroll-horizontal.js";
import { dm_vac_01_animated_intro_text } from "./modules/vac-01-animated-intro-text.js";
import { dm_vac_02_video_promo } from "./modules/vac-02-video-promo.js";
import { dm_vac_04_images } from "./modules/vac-04-images.js";
import { dm_vac_05_page_cards } from "./modules/vac-05-page-cards.js";
// import { dm_c_05_image_cards } from "./modules/soc-05-image-cards.js";
import { dm_a_va_01_search_jobs_cta } from "./modules/a-va-01-search-jobs-cta.js";
import { dm_a_03_more_people_stories } from './modules/a-03-more-people-stories.js';


// import './components/vacancy.js';

// import Swiper from 'swiper';
// import { Navigation } from 'swiper/modules';
// Swiper.use([Navigation]);
// // import { Autoplay, Pagination, Navigation, EffectFade } from 'swiper/modules';

jQuery(function ($) {
    "use strict";

    dm_reveal();
    dm_nav();
    // dm_nav_vacancy();
    dm_vimeo_modal();
    dm_back_to_top();

    dm_vah_01_homepage_header();
    // dm_h_02_header_with_media();
    // dm_a_02_latest_job_cards();
    dm_a_03_more_people_stories();
    // dm_c_05_feature_2();
    // dm_c_06_tabbed_slider();
    // dm_c_07_history_slider();
    // dm_c_10_featured_stories();
    dm_c_11_people_cards();
    // dm_c_13_video_cards();
    dm_c_14_perk_cards();
    // dm_search();

    // dm_geo_locate();
    // dm_applyCircleAnimationOnButtonHover();
    
    // dm_soh_01_header();
    dm_vac_01_animated_intro_text();
    dm_vac_02_video_promo();
    dm_vac_04_images();
    dm_vac_05_page_cards();
    dm_c_21_cards_scroll_horizontal();
    dm_a_va_01_search_jobs_cta();

	requestAnimationFrame(() => {
		ScrollTrigger.sort();
		ScrollTrigger.refresh();
	});
    // dm_soc_02_stats();
    // dm_c_05_image_cards();
});